import { Checkbox, Typography } from 'antd'
import React, { useState } from 'react'
import Button from '../../Button'
import Flex from '../../Flex'
import ApprovedModelIcon from '../../icons/ApproveModalIcon'
import SuccessIcon from '../../icons/SuccessIcon'
import Input from '../../Input/Input'
import {
  ContainerStyle,
  CountStyle,
  LabelWrapper,
  ShortlistDiv,
  StyledModal,
  TextDescription,
} from './style'
import SuccessModal from './SuccessModal'

const { Text } = Typography

const ActionRoleDrawer = ({
  description,
  textDescription,
  Icon = ApprovedModelIcon,
  showDrawer,
  setShowDrawer,
  onCloseClick,
  checkboxOptions = [],
  closeText = 'No',
  YesText = 'Yes',
  showYes = true,
  percentWeight = '90%',
  closeButtonHeight = '38px',
  closeButtonWidth = 'auto',
  yesButtonHeight = '38px',
  yesButtonWidth = 'auto',
  maxReasonLength = 35,
  reasonPlaceholder = 'Enter reason for opting out of the placement process',
  validationMessages = {
    selectOption: 'Please select an option before proceeding.',
    enterReason: 'Please enter the reason before proceeding.',
    reasonTooLong: 'Maximum 35 Character allowed!',
  },
  successModalMessage = 'SuccessFully',
  onApprove,
  showOptions = false,
  handleCloseDrawer = () => {},
  onSuccessCloseClick = () => {},
  closeValidation = () => {},
}) => {
  const [error, setError] = useState('')
  const [selectedValue, setSelectedValue] = useState(null)
  const [reason, setReason] = useState('')
  const [successModal, setSuccessModal] = useState(false)

  const onClose = () => {
    if (closeValidation && showOptions) {
      closeValidation()
    }

    setSelectedValue('')
    setError('')
    onCloseClick()
  }

  const onClick = value => {
    setReason('')
    setSelectedValue(prev => (prev === value ? null : value))
    if (value) {
      setError('')
    }
  }

  const onValidation = () => {
    if (!selectedValue && showOptions) {
      return setError(validationMessages.selectOption)
    }
    if (selectedValue === 'OTHERS') {
      if (!reason.trim()) return setError(validationMessages.enterReason)
      if (reason.length > maxReasonLength)
        return setError(`Maximum ${maxReasonLength} Character allowed!`)
    }
    if (showOptions) {
      onApprove(selectedValue, reason)
    }

    setError('')
    setShowDrawer(false)
    setSuccessModal(true)
  }
  const onSuccessClose = () => {
    onSuccessCloseClick()
    setError('')
    setSelectedValue('')
  }
  return (
    <div>
      <StyledModal
        open={showDrawer}
        centered
        footer={''}
        width={700}
        maskClosable={false}
        closable={false}
      >
        {Icon && <Icon />}
        <ShortlistDiv
          percentHeight={'max-height'}
          percentWeight={percentWeight}
        >
          {description}
        </ShortlistDiv>

        {textDescription && (
          <TextDescription> {textDescription}</TextDescription>
        )}
        {showOptions && (
          <>
            <Flex
              style={{ gap: '1em !important', justifyContent: 'space-evenly' }}
            >
              {checkboxOptions.map((option, index) => (
                <div
                  key={option}
                  style={{
                    border: '#DFDFDF 1px solid',
                    borderRadius: '12px',
                    padding: '1em',
                    height: 'auto',
                  }}
                >
                  <Checkbox
                    onClick={() => onClick(option?.value)}
                    checked={selectedValue === option?.value}
                  >
                    <LabelWrapper>{option?.label}</LabelWrapper>
                  </Checkbox>
                </div>
              ))}
            </Flex>

            {selectedValue === 'OTHERS' && (
              <ContainerStyle>
                <Typography level={5}>Enter reason</Typography>
                <Input
                  type="text"
                  value={reason}
                  onChange={e => setReason(e.target.value)}
                  count={{ show: true, max: maxReasonLength }}
                  maxLength={maxReasonLength}
                  placeholder={reasonPlaceholder}
                />
                <CountStyle>
                  <Text disabled>{`${reason.length}/${maxReasonLength}`}</Text>
                </CountStyle>
              </ContainerStyle>
            )}

            <div style={{ color: 'red', height: '2vh', width: '100%' }}>
              {error}
            </div>
          </>
        )}

        <Flex
          style={{
            gap: '1em !important',
            padding: '2em',
            justifyContent: 'center',
          }}
        >
          <Button.Secondary
            text={closeText}
            width={closeButtonWidth}
            height={closeButtonHeight}
            onClick={onClose}
          />
          {showYes && (
            <Button.Primary
              text={YesText}
              width={yesButtonWidth}
              height={yesButtonHeight}
              onClick={() => {
                showOptions ? onValidation() : handleCloseDrawer()
              }}
            />
          )}
        </Flex>
      </StyledModal>

      <SuccessModal
        showDrawer={successModal}
        setShowDrawer={setSuccessModal}
        description={successModalMessage}
        Icon={SuccessIcon}
        handleCloseDrawer={onSuccessClose}
      />
    </div>
  )
}

export default ActionRoleDrawer
